<template>
  <div class="mt-4">
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <b-card
        no-body
        class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
      >
        <b-navbar
          class="background-white"
          toggleable="lg"
        >
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-navbar-brand
            href="#"
            class="text-dark"
          >
            <strong>New Employee Settings</strong>
          </b-navbar-brand>

          <b-collapse
            id="nav-collapse"
            is-nav
          >
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <!-- v-if="appDeveloperOnly == 1" -->
                <b-button
                  class="my-2 my-sm-0 mr-2"
                  variant="outline-secondary"
                  size="sm"
                  @click="showUpdateAllModelsConfirmation = !showUpdateAllModelsConfirmation"
                >
                  Update All Models
                </b-button>
                <b-button
                  class="my-2 my-sm-0 mr-2"
                  variant="outline-primary"
                  size="sm"
                  @click="onAddClick"
                >
                  <!-- <font-awesome-icon icon="plus" /> -->
                  Add New Employee Setting
                </b-button>
                <b-button
                  variant="outline-info"
                  size="sm"
                  class="mr-2"
                  @click="reloadTable"
                >
                  <!-- <font-awesome-icon icon="sync" /> -->
                  Reload
                </b-button>
                <b-form-group>
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                      >Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <b-table
          class="main-table"
          hover
          striped
          sticky-header="calc(100vh - 295px)"
          fixed
          ref="table"
          id="employee-table"
          :busy.sync="isLoading"
          :fields="staticFields"
          :items="getWorkFlowSettingsTableData"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          no-sort-reset
        >
          <template v-slot:cell(is_active)="data">
            <b-badge :variant="data.item.is_active == 1 ? 'success' : 'danger'">{{data.item.is_active == 1 ? 'Active' : 'Inactive'}}</b-badge>
          </template>
          <template v-slot:cell(actions)="data">
            <div style="display: contents;">
              <b-btn
                v-if="data.item.is_active == 0"
                variant="outline-success"
                size="sm"
                class="mr-2"
                @click="onActivateWorkflowSetting(data)"
              >Activate</b-btn>
              <b-btn
                v-if="data.item.is_active == 1"
                variant="outline-danger"
                size="sm"
                class="mr-2"
                @click="onDeactivateWorkflowSetting(data)"
              >Deactivate</b-btn>
            </div>
            <b-btn
              class="mr-2"
              variant="outline-info"
              size="sm"
              @click="onEditWorkflowModal(data.item)"
            >
              <font-awesome-icon icon="edit" />
            </b-btn>
            <b-btn
              @click="onDuplicateWorkFlow(data.item)"
              variant="outline-warning"
              size="sm"
            >
              <font-awesome-icon icon="copy"></font-awesome-icon>
            </b-btn>
          </template>
        </b-table>
        <template v-slot:footer>
          <b-row>
            <b-col cols="2">
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <p class="text-center">
                Showing Result From
                <b>{{fromRows}}</b> to
                <b>{{toRows}}</b>
              </p>
            </b-col>
            <b-col cols="4">
              <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                aria-controls="employee-table"
              ></b-pagination>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </b-overlay>
    <b-overlay
      :show="showChangeStatusModal"
      no-wrap
    >
      <template v-slot:overlay>
        <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
        >
          <font-awesome-icon
            size="lg"
            icon="cloud-upload-alt"
          />
          <div
            v-if="activateWorkflowSetting"
            class="mb-3"
          >Activating...</div>
          <div
            v-else-if="deactivateWorkflowSetting"
            class="mb-3"
          >Deactivating...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetChangeStatusModal"
            >Cancel</b-button>
            <b-button
              variant="outline-danger"
              @click="changeStatusCall"
            >Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <b-overlay
      :show="showUpdateAllModelsConfirmation"
      no-wrap
    >
      <template v-slot:overlay>
        <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
        >
          <font-awesome-icon
            size="lg"
            icon="cloud-upload-alt"
          />
          <div class="mb-3">Updating...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure you want to update all existing models for <b>Employees</b>?</strong>
          </p>
          <div class="d-flex justify-content-center">
            <b-button
              variant="outline-success"
              class="mr-3"
              @click="resetUpdateAllModelsConfirmation"
            >Cancel</b-button>
            <b-button
              variant="outline-danger"
              @click="updateAllModelsConfirmationCall"
            >Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <AddNewEmployeeModal />
  </div>
</template>
<script>
import { HTTP } from "../../../../utils/HTTP";
import { EventBus } from "@/event-bus.js";
import AddNewEmployeeModal from "./addNewEmployeeModal.vue";
export default {
  name: "WorkflowHrNewEmployeeTable",
  components: {
    AddNewEmployeeModal,
  },
  data () {
    return {
      appDeveloperOnly: process.env.VUE_APP_DEVEVLOPER_ONLY,
      isLoading: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        // { key: "age", label: "Age", sortable: true },
        { key: "title", label: "Title", sortable: true },
        { key: "version", label: "Version", sortable: true },
        // { key: "workflow_type", label: "Workflow Type", sortable: true },
        { key: "is_active", label: "Status", sortable: true },
        { key: "actions", label: "Actions", sortable: false },
      ],
      workflowSettingId: null,
      showChangeStatusModal: false,
      processing: false,
      counter: 1,
      interval: null,
      activateWorkflowSetting: false,
      deactivateWorkflowSetting: false,
      showUpdateAllModelsConfirmation: false
    };
  },
  beforeDestroy () {
    this.clearInterval();
  },
  methods: {
    clearInterval () {
      if ( this.interval ) {
        clearInterval( this.interval );
        this.interval = null;
      }
    },
    resetUpdateAllModelsConfirmation () {
      this.showUpdateAllModelsConfirmation = this.processing = false;
    },
    updateAllModelsConfirmationCall () {
      this.counter = 1;
      this.processing = true;
      this.updateAllModelsConfirmationApiCall();
      this.clearInterval();
      this.interval = setInterval( () => {
        if ( this.counter < 20 ) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick( () => {
            this.resetUpdateAllModelsConfirmation();
          } );
        }
      }, 100 );
    },
    async updateAllModelsConfirmationApiCall () {
      this.isLoading = true;
      try {
        await HTTP( "get", "api/v1/workflow/settings/update/7", null );
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    resetChangeStatusModal () {
      this.activateWorkflowSetting = false;
      this.deactivateWorkflowSetting = false;
      this.workflowSettingId = null;
      this.showChangeStatusModal = this.processing = false;
    },
    changeStatusCall () {
      this.counter = 1;
      this.processing = true;
      if ( this.activateWorkflowSetting ) {
        this.activateWorkflow().then( this.reloadTable );
      } else if ( this.deactivateWorkflowSetting ) {
        this.deactivateWorkflow().then( this.reloadTable );
      }
      this.clearInterval();
      this.interval = setInterval( () => {
        if ( this.counter < 20 ) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick( () => {
            this.resetChangeStatusModal();
          } );
        }
      }, 100 );
    },
    onAddClick () {
      EventBus.$emit( "onShowAddNewEmployeeModal", "" );
    },
    onEditWorkflowModal ( data ) {
      EventBus.$emit( "onShowEditWorkflowSettingModal", data );
    },
    onDuplicateWorkFlow ( data ) {
      EventBus.$emit( "onShowDuplicateWorkflowSettingModal", data );
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-table" );
    },
    async getWorkFlowSettingsTableData () {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
        workflow_type_id: 7,
      };
      this.isLoading = true;
      let result = HTTP(
        "post",
        "api/v1/workflow/settings/get-by-type-id",
        formData
      );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          this.$store.state.employeesLazyLoad = false;
          return items;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
    onActivateWorkflowSetting ( data ) {
      this.workflowSettingId = data.item.id;
      this.activateWorkflowSetting = true;
      this.showChangeStatusModal = true;
    },
    async activateWorkflow () {
      let formData = {
        workflow_setting_id: this.workflowSettingId,
        is_active: 1,
        activated_by_id: localStorage.getItem( "userId" ),
        user_id: localStorage.getItem( "userId" ),
        workflow_type_id: 7,
      };
      try {
        await HTTP( "post", "api/v1/workflow/settings/update", formData );
      } catch ( err ) {
        return [err];
      }
    },
    onDeactivateWorkflowSetting ( data ) {
      this.workflowSettingId = data.item.id;
      this.deactivateWorkflowSetting = true;
      this.showChangeStatusModal = true;
    },
    async deactivateWorkflow () {
      let formData = {
        workflow_setting_id: this.workflowSettingId,
        is_active: 0,
        deactivated_by_id: localStorage.getItem( "userId" ),
        user_id: localStorage.getItem( "userId" ),
        workflow_type_id: 7,
      };
      try {
        await HTTP( "post", "api/v1/workflow/settings/update", formData );
      } catch ( err ) {
        return [err];
      }
    },
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
};
</script>